import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import TextGroup from '../../components/TextGroup/TextGroup';
import ProductBanner from '../../components/ProductBanner/ProductBanner';
import ProductSection from '../../components/ProductSection/ProductSection';

class Billing extends Component {
    render() {
        return (
            <Auxiliary>
                <Head {...this.props} id="billing" />
                <ProductBanner imgPadding {...this.props} page="billing" />
                <ProductSection {...this.props} facilities page="billing" section="features">
                    <TextGroup {...this.props} page="billing" section="features" />
                    <TextGroup noPadBottom {...this.props} page="billing" section="demo" />
                </ProductSection>
            </Auxiliary>
        )
    }
}

export default withTranslation()(Billing);